module.exports = __webpack_public_path__ + "static/media/Icon-03@2x.88dc1e14.png";